import React, { useState } from "react";
import { Box } from "@mui/material";
import { Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";

interface Option {
  id: number;
  text: string;
  label?: string;
}

// 옵션 리스트
export const goal5OptionList: Option[] = [
  { id: 1, text: "우울 (우울감, 무기력, 희망 없음)", label: "우울" },
  { id: 2, text: "범불안 (만사 걱정)", label: "범불안" },
  { id: 3, text: "공황 (급격한 불안 공포)", label: "공황" },
  { id: 4, text: "사회불안 (대인관계 불안)", label: "사회불안" },
  { id: 5, text: "강박 (강박적인 생각과 행동)", label: "강박" },
  { id: 6, text: "트라우마 (괴로운 과거 경험)", label: "트라우마" },
  { id: 7, text: "분노 (분노 조절 문제)", label: "분노" },
  { id: 8, text: "잘 모르겠음" },
];

export default function Goal_5_Promotion({
  version = "promotion",
}: {
  version?: string; // v5...
}) {
  const [isAnimating, setIsAnimating] = useState(false); // 애니메이션 상태 추가

  const pageKey = "goal_5"; // 페이지를 구분할 키 값

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${version}-onboarding/goal/6`, // 다음 페이지 경로 지정
    });

  const { trackSingleSelection } = usePromotionOnboardingTracking(pageKey);

  // 버튼 선택 로직
  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);
    trackSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    // ➊ 내용이 버튼 뒤에 가려지지 않도록 충분한 패딩을 줍니다.
    <Stack
      spacing={5}
      sx={{ paddingBottom: "40px" }} // 하단 버튼 높이보다 넉넉하게
    >
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{ color: theme.vars.palette.Content.Strong }}
      >
        {"최근 들어 나의 일상을 흔드는 문제는 무엇인가요?"}
      </CustomTypography>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {goal5OptionList.map(({ id, text, label }, optionIndex) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                size={"lg"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                sx={{
                  transition: "background-color 0.3s ease", // ease 애니메이션 추가
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {text}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
